import { User } from "lucide-react";
import React from "react";

function MyButton({ className = "", onClick, icon, title, color }) {
  const Icon = icon || User;
  return (
    <div
      onClick={() => onClick && onClick()}
      className={`w-full   ${className}    items-center justify-center  flex flex-row rounded-lg border  space-x-1  cursor-pointer ${color.border} ${color.hover} `}
    >
      <Icon
        className={`w-5 h-5  rounded-lg  ${color.text}  `}
      />
       <span className={`text-xs font-semibold  ${color.text}`} >
          {title}
        </span>

    </div>
  );
}
export default MyButton;
